import React from 'react';
import { Check } from 'lucide-react';
import { img, audience } from '../mock';

const TextOnImage = ({ image, title, highlight, children }) => (
  <div className="relative rounded-3xl overflow-hidden border border-white/10 reveal">
    <div className="absolute inset-0">
      <img src={image} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0c0c0e] via-[#0c0c0e]/85 to-[#0c0c0e]/40" />
    </div>
    <div className="relative p-8 md:p-14 lg:p-20 max-w-3xl">
      <h2 className="font-display font-semibold text-white text-3xl md:text-5xl leading-tight">
        {title} <span className="gold-text">{highlight}</span>
      </h2>
      <div className="mt-6 space-y-4 text-neutral-300 leading-relaxed text-base md:text-lg">{children}</div>
    </div>
  </div>
);

const WhyAudience = () => {
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 space-y-8">
      <TextOnImage image={img.why} title="Perchè" highlight="imparare Unreal adesso?">
        <p>
          Il settore della visualizzazione architettonica sta cambiando a una velocità che non ha precedenti. I
          grandi studi internazionali hanno già fatto il passaggio, e chi lavora ancora solo con il rendering
          offline si trova a competere con tempi, costi e output che non reggono più il confronto.
        </p>
        <p>
          Unreal Engine non è una moda. È lo strumento che permette di lavorare su scene fotorealistiche,
          velocemente, presentare ai clienti esperienze che nessun render statico potrà mai eguagliare.
        </p>
        <p className="text-white font-medium">Chi lo padroneggia oggi ha un vantaggio concreto, misurabile, sul mercato.</p>
      </TextOnImage>

      <TextOnImage image={img.ai} title="L&rsquo;" highlight="AI sostituirà tutto questo?">
        <p>È la domanda che rimbalza ovunque. E la risposta che nessuno vuole sentire è: <span className="text-white">dipende da te.</span></p>
        <p>
          L&rsquo;AI non sostituirà chi sa lavorare. Sostituirà chi non sa fare niente di più che cliccare
          &ldquo;generate&rdquo;. Generare un&rsquo;immagine bella oggi è più semplice, ma i problemi arrivano su
          commesse reali. Lì, senza una base, ci si perde.
        </p>
        <p>
          <span className="gold-text">Chi conosce Unreal Engine parte da una posizione completamente diversa.</span> Può
          usare l&rsquo;AI come strumento di ispirazione, guidare le generazioni con intenzione, e usare la velocità
          di Unreal per costruire pre-visualizzazioni solide.
        </p>
      </TextOnImage>

      {/* Audience */}
      <div id="masterclass" className="pt-8 scroll-mt-24">
        <div className="text-center max-w-3xl mx-auto mb-12 reveal">
          <h2 className="font-display font-semibold text-white text-3xl md:text-5xl">
            Per chi è questa <span className="gold-text">Masterclass?</span>
          </h2>
          <p className="mt-4 text-neutral-400">
            Parti da zero o hai già esperienza? Tranquillo! Il corso ti accompagna dai concetti fondamentali della
            modellazione 3D fino alla produzione di contenuti fotorealistici con Unreal Engine 5.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {audience.map((a, i) => (
            <div
              key={a.n}
              style={{ transitionDelay: `${i * 0.12}s` }}
              className={`card-shine relative rounded-2xl overflow-hidden border border-white/10 bg-[var(--uv-surface)] ${['reveal-left', 'reveal', 'reveal-right'][i] || 'reveal'}`}
            >
              <div className="h-40 overflow-hidden relative">
                <img src={img[a.image]} alt="" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--uv-surface)] to-transparent" />
                <span className="absolute top-4 left-5 font-mono-uv text-[var(--uv-gold)] text-sm">{a.n}</span>
              </div>
              <div className="p-6">
                <h3 className="font-display font-semibold text-white text-xl leading-snug">{a.title}</h3>
                <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{a.text}</p>
                <ul className="mt-5 space-y-2.5">
                  {a.points.map((p, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-sm text-neutral-300">
                      <Check size={16} className="text-[var(--uv-gold)] mt-0.5 shrink-0" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyAudience;
